import { render, staticRenderFns } from "./AddingLabelProfilePopup.vue?vue&type=template&id=cd59bc2e"
import script from "./AddingLabelProfilePopup.vue?vue&type=script&lang=js"
export * from "./AddingLabelProfilePopup.vue?vue&type=script&lang=js"
import style0 from "./AddingLabelProfilePopup.vue?vue&type=style&index=0&id=cd59bc2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports